"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var emoji_mart_1 = require("emoji-mart");
require("emoji-mart/css/emoji-mart.css");
var PICKER_WIDTH = 340;
var EmojiPicker = /** @class */ (function (_super) {
    __extends(EmojiPicker, _super);
    function EmojiPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.pickElement = null;
        _this.$btn = null;
        _this.state = {
            open: false
        };
        _this.bindEvent = function () {
            return document.addEventListener('click', _this.listenClickEvent, true);
        };
        _this.unBindEvent = function () {
            return document.removeEventListener('click', _this.listenClickEvent, true);
        };
        _this.selectEmoji = function (emoji) {
            _this.props.editor.insertText(emoji.native);
            _this.hide();
        };
        _this.listenClickEvent = function (e) {
            if (_this.$btn && _this.$btn.contains(e.target))
                return;
            if (_this.state.open &&
                _this.pickElement &&
                !_this.pickElement.contains(e.target)) {
                requestAnimationFrame(function () { return _this.hide(); });
            }
        };
        _this.open = function () {
            _this.setState({
                open: true
            });
            _this.bindEvent();
        };
        _this.hide = function () {
            _this.fixPos();
            _this.setState({
                open: false
            });
            _this.unBindEvent();
        };
        _this.toggleVisible = function () { return (_this.state.open ? _this.hide() : _this.open()); };
        _this.$btn = props.mountDOM.querySelector('.syl-toolbar-button');
        return _this;
    }
    EmojiPicker.prototype.componentDidMount = function () {
        this.$btn && this.$btn.addEventListener('click', this.toggleVisible);
    };
    EmojiPicker.prototype.componentWillMount = function () {
        this.$btn && this.$btn.removeEventListener('click', this.toggleVisible);
    };
    EmojiPicker.prototype.fixPos = function () {
        var mountDOM = this.props.mountDOM;
        if (!mountDOM || !this.pickElement || !this.pickElement.parentElement) {
            return;
        }
        var rect = mountDOM.getBoundingClientRect();
        var avWidth = window.innerWidth;
        if (avWidth - rect.left < PICKER_WIDTH) {
            this.pickElement.parentElement.setAttribute('style', "margin-left: -" + (PICKER_WIDTH - (rect.right - rect.left)) + "px");
        }
        else {
            this.pickElement.parentElement.setAttribute('style', '');
        }
    };
    EmojiPicker.prototype.render = function () {
        var _this = this;
        var open = this.state.open;
        if (!open) {
            return null;
        }
        return (react_1.default.createElement("div", { ref: function (el) {
                if (el) {
                    _this.pickElement = el;
                }
            } },
            react_1.default.createElement(emoji_mart_1.Picker, { set: "messenger", onSelect: this.selectEmoji, style: { width: PICKER_WIDTH, position: 'absolute', zIndex: 2 }, backgroundImageFn: this.props.backgroundImageFn
                    ? this.props.backgroundImageFn
                    : undefined })));
    };
    return EmojiPicker;
}(react_1.default.Component));
exports.EmojiPicker = EmojiPicker;
//# sourceMappingURL=index.js.map